
'format es6';

import gsap from 'greensock';
import $ from 'jquery';
import ns from 'ns';
import User from '../User';
import Api from '../Api';
import Store from 'store';

import { factory as sectionFactory } from './Section';
import { factory as questionFactory } from './DomainQuestion';

require('../../views-compiled/domain.quiz');

const ANSWER_RANGE = 3; // jo!
const EASING = gsap.Expo;
const DOMAIN_RESULT_PARTIAL_KEY = 'user.domain_result';
const REQUESTED_PROFILE_RESULT_KEY = 'requested_profile_result';
const SHOW_ROLLBACK_KEY = 'show_rollback';
const MAX_QUESTIONS = 24;

function DomainQuiz() {
	this.templateName = 'domain.quiz.htm';

	let nQuestionsTotal;
	let currentQuestionIdx;
	let questionContainer;
	let currentIndexContainer;
	let domain;

	let questions;

	const answers = [];

	this.setDomain = (requestedDomain) => {
		domain = requestedDomain;
	};

	this.setAnimation = (tl, rootNode, setInEndTime) => {
		tl.from(rootNode, 1, { opacity: 0, ease: EASING.easeIn });
		const animateInFinish = setInEndTime();
		tl.to(rootNode, 1, { opacity: 0, ease: EASING.easeOut }, animateInFinish);
		return tl;
	};

	/**
	 * Loads the domain questions (for each categories), then randomises the data while 
	 * verifying that at least 2 questions per category are served to the user and 
	 * puts them in the questions variable.
	 * 
	 * It then sets general templates values and the promise resolve with that object.
	 *
	 * @Promise {Object} tplValues
	 * @Reject {void} - Console logs the arguments.  
	 * 
	 * @return {Promise}
	 */
	this.init = () => {
		return Api.request(`domain-questions/${ns.lang}/${domain.id}`).then((res) => {
			questions = res;
			currentQuestionIdx = 0;

			// Verify that we have at least 2 questions of each category (families)
			const families = [];
			const filteredQuestions = [];
                        // On poste toutes les questions du domaine!!!!
			if (0 && (questions.length > MAX_QUESTIONS)) {
				questions.forEach((q) => {
					if (families.indexOf(q.famille_id) === -1) {
						families.push(q.famille_id);
					}
				});

				const nPerFamily = Math.ceil(MAX_QUESTIONS / families.length);
				families.forEach((f) => {
					while (filteredQuestions.filter(q => q.famille_id === f).length < nPerFamily) {
						const questionsPerFamily = questions.filter(q => q.famille_id === f);
						let randIndex = Math.floor(Math.random() * (questionsPerFamily.length - 1));
						let newQ = questionsPerFamily[randIndex];

						while (filteredQuestions.indexOf(newQ) > -1) {
							randIndex = Math.floor(Math.random() * (questionsPerFamily.length - 1));
							newQ = questionsPerFamily[randIndex];
						}

						filteredQuestions.push(newQ);
					}
				});

				// Set to questions
				questions = filteredQuestions;
			}

			// Randomize
			questions = ns.shuffleArray(questions);
			nQuestionsTotal = questions.length;

			const tplValues = {
				currentQuestion: 0,
				nQuestionsTotal,
			};

			return tplValues;
		}).catch((res) => {
			console.log(res);
		});
	};

	const computeResults = () => {
		const answersByFamilies = questions.reduce((allDoms, question, qIdx) => {
			//jo! const answer = answers[qIdx];
			const answer = answers[qIdx]; //jo!
			const family_id = answer.family_id;
			const domainAnswers = allDoms[family_id] = allDoms[family_id] || [];
			domainAnswers.push(answer);
			return allDoms;
		}, {});

		const families = Object.keys(answersByFamilies).map((familyId) => {
			const familyAnswers = answersByFamilies[familyId];

			// Sum all the answers
			const points = familyAnswers.reduce((sum, val) => sum + parseInt(val.option, 10), 0);

			// Points / maximum points possible (each answer can only be 1 or 0)
			//const ratio = points / familyAnswers.length;
			// jo: correct points (1..4) to (0..3) by substracting 1 per answer!
			const ratio = (points - familyAnswers.length) / (familyAnswers.length * ANSWER_RANGE); //jo!

			return {
				id: familyId,
				points,
				ratio,
				name: domain.familles.find(family => family.id === familyId).nom,
			};
		});

		this.animateOut().then(() => {
			// Set the data needed for the domain (All of it's categories results + the domain itself)
			const res = {
				domain: Object.assign({
					slug: ns.domainSlugs.get(`${domain.id}_${ns.lang}`),
				}, domain),
				families: families.sort((fam1, fam2) => fam2.ratio - fam1.ratio),
				questions_stats: questions,
			};

			User.set(`${DOMAIN_RESULT_PARTIAL_KEY}_${domain.id}`, res);

			// Go to DomainResult
			this.next && this.next(res);
			this.next = null;
		});
	};

	/**
	 * Checks if we have only the same answer throughout the quiz.
	 * 
	 * Return the opposite value of the answers.some function.
	 * When array.some() returns true, then it breaks out of the loop ;
	 * meaning, when we find an answer that is different from the previousOne
	 * it breaks out of the loop with the value true. We want to know if we only
	 * have the same answers so we inverse the value.
	 */
	const onlySameAnswers = () => {
		let prevAnswer = answers[0].option;

		return !answers.some((answer) => {
			if (answer.option !== prevAnswer) {
				return true;
			}

			prevAnswer = answer.option;
			return false;
		});
	};

	this.prevQuestion = () => {
		currentQuestionIdx--;

		// If we have a prev question, add it!
		if (currentQuestionIdx < nQuestionsTotal) return this.addQuestion();

		// Else, compute the results
		computeResults();
	}


	this.nextQuestion = (answer) => {
		answers[currentQuestionIdx] = answer;
		questions[currentQuestionIdx].score = answer; // JO: questions stats!

		currentQuestionIdx++;
		if (currentQuestionIdx < nQuestionsTotal) return this.addQuestion();

//jo!		// Check if we have only the same answers, and if we do, go back 
//jo!		// to the domain selection part (ProfileResult).
//jo!		if (onlySameAnswers()) {
//jo!			this.rollback();
//jo!			return false;
//jo!		}

		computeResults();
	}

	this.addQuestion = () => {
		const questionView = questionFactory();
		currentIndexContainer.html(currentQuestionIdx + 1);

		const needsDiffAnswer = (currentQuestionIdx + 1) === nQuestionsTotal && onlySameAnswers();

		// Extend the question object with the currentQuestionIdx,
		// the current domain of the question, the total number of questions
		// and if we need a different answer to proceed (in case someone has 
		// put only the same answer).
		questionView.setData(Object.assign({
			currentQuestion: currentQuestionIdx + 1,
			currentDomain: {
				name: domain.nom,
				id: domain.id,
				slug: ns.domainSlugs.get(`${domain.id}_${ns.lang}`),
			},
			nQuestionsTotal,
			needsDiffAnswer,
		}, questions[currentQuestionIdx]));

		const onReady = questionView.render(questionContainer);
		onReady.then(() => {
			questionView.onNext(this.nextQuestion);
			questionView.onPrev(this.prevQuestion);
			questionView.animateIn();
		});
	}

	this.activate = () => {
		questionContainer = $('[data-question]', this.sectionNode);
		currentIndexContainer = $('[data-current]', this.sectionNode);

		this.addQuestion();
	};

	this.deactivate = () => {

	};

	this.rollback = () => {
		this.animateOut().then(() => {
			Store.set(REQUESTED_PROFILE_RESULT_KEY, domain.id);
			Store.set(SHOW_ROLLBACK_KEY, true);
			this.onFail && this.onFail();
		});
	};

	return this;
}


export function factory(instance) {
	return DomainQuiz.call(sectionFactory(instance || {}));
}
